import { Injectable } from '@angular/core';
import { MediaMetadata } from '@caballus/ui-common';
import { Capacitor } from '@capacitor/core';
import { FileSelectorPlugin } from '@ion-caballus/core/plugins';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VideoService {
    public moveVideoToThePermanentLocation(metaData: MediaMetadata): Observable<{
        mediaId: string;
        newPath: string;
    }> {
        if (Capacitor.isNativePlatform()) {
            return from(
                FileSelectorPlugin.MoveVideoFileToPermanentLocation({
                    filePath: metaData.filePath
                })
            ).pipe(
                map(result => ({
                    mediaId: metaData.mediaId,
                    newPath: result.newPath
                })),
                catchError(err => {
                    throw err;
                })
            );
        }

        return of({
            mediaId: metaData.mediaId,
            newPath: metaData.filePath
        });
    }
}
